<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5 text-uppercase" >{{page}}</h2>
      </div>
<!--      <div class="d-flex">-->
<!--        <div class="justify-content-center">-->
<!--          <router-link :to="`/${url}/add`" type="button" class="btn btn-primary my-2 btn-icon-text">-->
<!--            <i class="fe fe-plus-square mr-2"></i> Add {{page}}-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">{{page}} List</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="dataList" :fields="tableFields">
                <template #cell(created_at)="row">
                  <p>{{row.item.created_at | moment("MMMM Do YYYY")}}</p>
                </template>
                <template #cell(is_seen)="row">
                  <p>{{ row.item.is_seen === false ? 'NO' : 'YES' }}</p>
                </template>
                <template #cell(actions)="row">
                  <button @click="openAnswerModal(row.item)" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </button>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal hide-footer hide-header ref="answerModal">
      <div class="main-mail-compose-box">
        <div class="main-mail-compose-header"><span>CONTACT US</span>
          <nav class="nav">
            <div class="nav-link" @click="closeAnswerModal">
              <i class="fas fa-times"></i>
            </div>
          </nav>
        </div>
        <div v-if="formData" class="p-5">
          <p v-if="formData.email">{{formData.email}}</p>
          <p v-if="formData.created_at">{{formData.created_at | moment("MMMM Do YYYY")}}</p>
          <p v-if="formData.body">{{formData.body}}</p>
          <div v-if="formData.company_service">
            <h3>{{formData.company_service.title_l[$i18n.locale]}}</h3>
            <p>{{formData.company_service.description_l[$i18n.locale]}}</p>
            <img v-if="formData.company_service.icon" :src="formData.company_service.icon" alt="" class="mb-2">
            <img v-if="formData.company_service.image" :src="formData.company_service.image" alt="">
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'
const page = 'contactUs'
const url = 'contactUs'
export default {
  name: 'application',
  data () {
    return {
      page: page,
      url: url,
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      unseenContactUsCount: 0,
      pagination: {},
      formData: {}
    }
  },
  computed: {
    ...mapState({
      dataList: state => state[page].dataList
    }),
    tableFields () {
      return [
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'body',
          label: 'Body',
          sortable: true,
          thStyle: { width: '20%' },
          tdClass: 'contact-body'
        },
        {
          key: 'created_at',
          label: 'Created at',
          sortable: true
        },
        {
          key: 'company_service.title_l.' + this.$i18n.locale,
          label: 'Service Name',
          sortable: true
        },
        {
          key: 'is_seen',
          label: 'Is Seen',
          sortable: true
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getData({ count: this.paginationPerPage })
  },
  methods: {
    ...mapActions({
      getAllData: page + '/getAllData',
      getDataByID: page + '/getDataByID'
    }),
    openAnswerModal (item) {
      this.formData = item
      this.$refs.answerModal.show()
      this.getDataByID(this.formData.id)
    },
    closeAnswerModal () {
      this.getData()
      this.formData = null
      this.$refs.answerModal.hide()
    },
    getData (params) {
      this.getAllData(params).then(res => {
        this.pagination = res.pagination
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    changePaginationPerPage (value) {
      this.getData({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getData({ page: page, count: this.paginationPerPage })
    },
    removeItem (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteItem({ id }).then(res => {
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style>
  .is_main {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    cursor: pointer;
  }
</style>
